import { Selection } from "../../contracts";
import { selectionOutcomeTypeMapper } from "../selectionOutcomeTypeMapper";

export const getSelectionSide = (selection: Selection): number => {
    return selection.outcomeType && selectionOutcomeTypeMapper[selection.outcomeType];
}